class RestaurantProvider {

  constructor(restaurantCode, preloadedRestaurant) {
    this.restaurantCode = restaurantCode;
    this.restaurant = preloadedRestaurant;
  }

  get() {
    return this.restaurant;
  }

  getMenu() {
    return this.get().menu;
  }

  getOfflineMenus() {
    return this.get().offlineMenus;
  }

  getMeta() {
    return this.get().meta;
  }
}

export default RestaurantProvider;



// WEBPACK FOOTER //
// ./providers/restaurant.provider.js